var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "2차심사" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.editable &&
                                  !_vm.disabledPrint &&
                                  _vm.disabled,
                                expression:
                                  "editable && !disabledPrint && disabled",
                              },
                            ],
                            attrs: {
                              editable: _vm.editable,
                              label: "2차심사 보고서",
                              icon: "print",
                            },
                            on: { btnClicked: _vm.secondAuditPrint },
                          }),
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.editable && !_vm.disabled,
                                expression: "editable && !disabled",
                              },
                            ],
                            attrs: {
                              url: _vm.saveUrl,
                              isSubmit: _vm.isSave,
                              param: _vm.param.suggestion,
                              mappingType: "PUT",
                              label: "LBLSAVE",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.saveData,
                              btnCallback: _vm.saveCallback,
                            },
                          }),
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.editable && !_vm.disabled,
                                expression: "editable && !disabled",
                              },
                            ],
                            attrs: {
                              url: _vm.completeUrl,
                              isSubmit: _vm.isComplete,
                              param: _vm.param.suggestion,
                              mappingType: "PUT",
                              label: "완료",
                              icon: "check",
                            },
                            on: {
                              beforeAction: _vm.completeData,
                              btnCallback: _vm.completeCallback,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-select", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            type: "edit",
                            codeGroupCd: "SAI_SUGGESTION_SECOND_AUDIT_CD",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "suggestionSecondAuditCd",
                            label: "심사",
                          },
                          model: {
                            value: _vm.param.suggestion.suggestionSecondAuditCd,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.param.suggestion,
                                "suggestionSecondAuditCd",
                                $$v
                              )
                            },
                            expression:
                              "param.suggestion.suggestionSecondAuditCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "포상금",
                            suffix: "원",
                            type: "number",
                            name: "bountySecond",
                          },
                          model: {
                            value: _vm.param.suggestion.bountySecond,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.param.suggestion,
                                "bountySecond",
                                $$v
                              )
                            },
                            expression: "param.suggestion.bountySecond",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            rows: 16,
                            label: "심사의견",
                            name: "suggestionSecondAuditOpinion",
                          },
                          model: {
                            value:
                              _vm.param.suggestion.suggestionSecondAuditOpinion,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.param.suggestion,
                                "suggestionSecondAuditOpinion",
                                $$v
                              )
                            },
                            expression:
                              "param.suggestion.suggestionSecondAuditOpinion",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }